import { render, staticRenderFns } from "./ActiveChecksAllResultsPage.vue?vue&type=template&id=51073158"
import script from "./ActiveChecksAllResultsPage.vue?vue&type=script&lang=js"
export * from "./ActiveChecksAllResultsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports